import { QuoteListFilter } from '../../../enums/quoteListFilter'
import { QuoteRowStatus } from '../types/quoteRowStatus'

export const quoteRowStatusToTitleKey: Record<QuoteRowStatus, string> = {
  [QuoteListFilter.Draft]: 'quotes.table.status.draft',
  [QuoteListFilter.Pending]: 'quotes.table.status.pending',
  [QuoteListFilter.Rejected]: 'quotes.table.status.rejected',
  [QuoteListFilter.Accepted]: 'quotes.table.status.accepted',
  [QuoteListFilter.Invoiced]: 'quotes.table.status.invoiced',
}
